import { of } from 'rxjs';

export const MainMenu = (component) => [
    {
        icon: 'class',
        title: 'Artists',
        condition: component.notPromoter$,
        route: 'artists',
    },
    {
        icon: 'dashboard',
        title: 'Venues',
        condition: component.isPromoter$,
        route: 'venues',
    },
    // {
    //     title: 'Community',
    //     isLink: true,
    //     link: 'http://allaccessadvance.freshdesk.com',
    // },
];

export const SettingsMenu = (component) => [
    {
        icon: 'cancel',
        title: 'Logout',
        click: () => component.logout(),
        condition: of(true),
    },
];
